var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogonew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10315",
    "data-name": "Group 10315",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.514,
    height: 35.835,
    viewBox: "0 0 80.514 35.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_982",
    "data-name": "Rectangle 982",
    width: 80.514,
    height: 35.835,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10314",
    "data-name": "Group 10314",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37716",
    "data-name": "Path 37716",
    d: "M20.12,24.446l-1.85-2a23.948,23.948,0,0,0,1.138-2.615A7.3,7.3,0,1,0,5.235,16.389a6.972,6.972,0,0,0,2.549,7.167A7.116,7.116,0,0,0,12.762,25.2a6.409,6.409,0,0,0,3.13-.919.446.446,0,0,1,.664.079c.794.823,1.608,1.628,2.426,2.427a.462.462,0,0,1,.14.587,34.543,34.543,0,0,1-1.23,3.254A9.149,9.149,0,0,1,11.1,35.683a9.447,9.447,0,0,1-10.673-6.5A9.552,9.552,0,0,1,.6,23.034Q1.722,19.816,2.833,16.6c1-2.886,2.013-5.768,3-8.659a14.279,14.279,0,0,1,1.7-3.885A9.169,9.169,0,0,1,15.1,0a9.139,9.139,0,0,1,7.132,2.984A8.815,8.815,0,0,1,24.6,7.726a10.527,10.527,0,0,1-.524,5.309c-1.337,3.761-2.617,7.541-3.955,11.412",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37717",
    "data-name": "Path 37717",
    d: "M84.016,144.907a4.58,4.58,0,1,1,0-9.159,4.58,4.58,0,1,1,0,9.159",
    transform: "translate(-71.643 -122.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37718",
    "data-name": "Path 37718",
    d: "M383.706,93.178v4.616h-1.327V90.077c.482,0,.984-.028,1.479.02.126.012.262.251.335.413.586,1.285,1.159,2.577,1.839,3.856V90.1H387.4V97.82a12.249,12.249,0,0,1-1.28-.017c-.122-.013-.258-.219-.326-.365-.6-1.3-1.188-2.615-1.781-3.923-.057-.126-.127-.247-.19-.37l-.116.033",
    transform: "translate(-344.886 -81.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37719",
    "data-name": "Path 37719",
    d: "M376.937,194.374c0,.917-.018,1.8.009,2.677.011.362-.109.462-.449.435s-.684-.006-1.07-.006v-7.89c1.074.062,2.164.052,3.23.209a1.929,1.929,0,0,1,1.538,1.976c0,1.273-.138,1.594-1.1,2.267l1.44,3.438c-.536,0-1,.024-1.464-.016-.125-.011-.281-.2-.342-.337-.331-.77-.623-1.558-.957-2.327-.265-.61-.07-.464-.832-.427m.033-3.446V193c.556-.055,1.207.221,1.515-.394a1.566,1.566,0,0,0,.032-1.2c-.284-.626-.943-.483-1.546-.483",
    transform: "translate(-338.616 -171.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37720",
    "data-name": "Path 37720",
    d: "M678.474,197.8a1.434,1.434,0,0,1-.174.042c-1.452.071-1.452.071-2-1.264-.195-.477-.421-.943-.58-1.431-.133-.409-.359-.542-.816-.4,0,.825-.019,1.67.008,2.514.013.422-.075.649-.555.594a8.811,8.811,0,0,0-.963-.006V190c1.172.09,2.375-.218,3.531.278a1.963,1.963,0,0,1,1.233,1.769,2.085,2.085,0,0,1-1.135,2.317l1.449,3.436m-3.534-6.509v2.054c.551-.017,1.192.213,1.489-.341a1.613,1.613,0,0,0,.013-1.275c-.277-.584-.923-.449-1.5-.438",
    transform: "translate(-607.369 -171.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37721",
    "data-name": "Path 37721",
    d: "M320.417,97.707V89.969c1.177.078,2.347-.187,3.474.264a2.053,2.053,0,0,1,1.275,2c.048,1.091.02,2.186.009,3.28a2.2,2.2,0,0,1-2.223,2.213c-.783,0-1.566,0-2.349,0-.049,0-.1-.008-.187-.016m1.541-6.357v4.967c.95.258,1.588-.034,1.69-.941a16.009,16.009,0,0,0,.013-3.026.972.972,0,0,0-.942-1c-.24-.018-.483,0-.761,0",
    transform: "translate(-288.999 -81.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37722",
    "data-name": "Path 37722",
    d: "M558.658,193.055c.539-.894,1.069-1.795,1.628-2.677a.716.716,0,0,1,.469-.3c.432-.041.871-.014,1.4-.014-.262.435-.477.806-.706,1.168-.364.575-.724,1.153-1.115,1.71a.5.5,0,0,0-.023.607c.634,1.288,1.244,2.589,1.859,3.887.06.126.1.262.177.468-.565,0-1.062.015-1.557-.013-.094-.005-.206-.171-.262-.285-.47-.952-.928-1.91-1.394-2.874-.99.906-.363,2.089-.617,3.174-.392,0-.812.024-1.226-.016a.456.456,0,0,1-.275-.344c-.016-2.465-.012-4.929-.012-7.438h1.547v2.911Z",
    transform: "translate(-502.383 -171.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37723",
    "data-name": "Path 37723",
    d: "M707.906,94.845v3.31h-1.522V90.465H707.9v3.1c.641,0,1.226.019,1.806-.019.1-.006.255-.258.259-.4.024-.88.012-1.762.012-2.68h1.439v7.683h-1.439c0-.951-.012-1.908.006-2.863.007-.343-.1-.465-.449-.45-.519.023-1.039.006-1.628.006",
    transform: "translate(-637.121 -81.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37724",
    "data-name": "Path 37724",
    d: "M770.595,92.923c.044-.762.042-1.53.144-2.284a1.9,1.9,0,0,1,1.808-1.68,2.551,2.551,0,0,1,2.382.657,2.365,2.365,0,0,1,.6,1.638c.027,1.111.018,2.223.005,3.334a2.135,2.135,0,0,1-2.307,2.308,2.548,2.548,0,0,1-1.871-.515,2.254,2.254,0,0,1-.717-1.69c-.023-.588-.005-1.177-.005-1.765l-.042,0m1.469.035c.046.642.067,1.29.147,1.931a.8.8,0,0,0,.877.713c.486-.017.862-.266.874-.716.034-1.329.037-2.66,0-3.988-.013-.432-.391-.583-.809-.594-.439-.011-.86.058-.93.562-.1.689-.107,1.389-.156,2.093",
    transform: "translate(-695.036 -80.195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37725",
    "data-name": "Path 37725",
    d: "M436.143,197.865a.535.535,0,0,1-.1.043c-1.371.066-1.379.068-1.679-1.291a.382.382,0,0,0-.465-.355,4.624,4.624,0,0,1-.977-.005c-.544-.089-.723.165-.828.651-.226,1.05-.248,1.046-1.339,1.016-.107,0-.215-.015-.379-.028.2-.846.387-1.654.586-2.458.409-1.654.833-3.3,1.23-4.961.069-.289.175-.411.479-.395.423.022.851-.02,1.271.02a.532.532,0,0,1,.387.3c.483,1.982.938,3.972,1.407,5.957.118.5.263.99.4,1.51m-2.2-2.99L433.3,192.1l-.084.013-.636,2.758Z",
    transform: "translate(-388.178 -171.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37726",
    "data-name": "Path 37726",
    d: "M444.623,90.037c.537,0,1.044.021,1.547-.008.313-.018.421.115.486.391.576,2.44,1.161,4.877,1.75,7.342h-1.428a8.812,8.812,0,0,1-.3-1.175c-.042-.344-.208-.386-.487-.374a5.251,5.251,0,0,1-1.028-.006c-.521-.082-.686.19-.767.624-.058.313-.148.62-.223.928H442.7l1.919-7.721m1.648,4.779-.665-2.809-.092.019-.648,2.79Z",
    transform: "translate(-399.296 -81.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37727",
    "data-name": "Path 37727",
    d: "M596.332,98.006h-.305c-1.227.013-1.245.015-1.434-1.2-.048-.305-.152-.383-.429-.374-.457.014-.917-.02-1.371.018a.542.542,0,0,0-.373.306c-.139.393-.219.807-.332,1.249h-1.47l1.913-7.734h1.935l1.866,7.734m-2.821-5.837-.073.016-.652,2.845h1.4l-.671-2.861",
    transform: "translate(-532.706 -81.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37728",
    "data-name": "Path 37728",
    d: "M496.309,193.123c0,.556-.007,1.111,0,1.667a.93.93,0,1,0,1.856.006c-.008-.762.036-.651.726-.655.941-.005.9.031.8.967-.225,2.22-2.784,2.435-4.057,1.595a2.271,2.271,0,0,1-.889-1.96c-.043-1.093-.059-2.192,0-3.284a2.21,2.21,0,0,1,2.393-2.345,2.256,2.256,0,0,1,2.582,2.228c.049.363-.054.529-.431.5a3.132,3.132,0,0,0-.49,0c-.408.034-.675-.007-.654-.555.02-.522-.391-.812-.944-.8a.827.827,0,0,0-.9.868c-.018.588,0,1.177,0,1.765",
    transform: "translate(-446.205 -170.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37729",
    "data-name": "Path 37729",
    d: "M622.594,196.866v1.376h-4.155v-7.788h4.052v1.325H620v1.707c.489,0,.973.016,1.455-.005.352-.016.489.091.484.469-.01.965.007.966-.951.966h-.993v1.951Z",
    transform: "translate(-557.8 -171.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37730",
    "data-name": "Path 37730",
    d: "M541.879,94.71v2.965h-1.54V89.961a12.98,12.98,0,0,1,3.412.2,2.178,2.178,0,0,1,1.45,2.506,2.145,2.145,0,0,1-2,1.907c-.433.038-.864.086-1.321.133m-.006-1.309c.627-.035,1.33.182,1.632-.489a1.627,1.627,0,0,0-.039-1.271c-.335-.619-1.011-.369-1.593-.385Z",
    transform: "translate(-487.357 -81.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37731",
    "data-name": "Path 37731",
    d: "M317.879,191.871h-1.641v-1.328h4.937v1.331H319.46v6.469a13.463,13.463,0,0,1-1.38-.022c-.082-.009-.191-.3-.193-.465-.014-1.795-.009-3.589-.009-5.384Z",
    transform: "translate(-285.23 -171.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37732",
    "data-name": "Path 37732",
    d: "M651.27,90.562v1.312h-1.74v6.369h-1.454V91.909h-1.763V90.562Z",
    transform: "translate(-582.941 -81.682)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogonew);
export default __webpack_public_path__ + "static/media/logonew.178f90ce47e07f19a115441581953b82.svg";
export { ForwardRef as ReactComponent };